import React, { useState, useEffect } from "react";
import { Container, Spinner, Row, Col, Button } from "react-bootstrap";
import { Toaster } from "sonner";
import style from "./Perfil.module.css";
import { CgProfile } from "react-icons/cg";
import { MdOutlineLogout } from "react-icons/md";
import { IoMdNotificationsOutline } from "react-icons/io";
import { getUserByEmail } from "../../utils";
import { useAppContext } from "../../context/index.jsx";
import ProfileContactSection from "./ProfileSections/ProfileContactSection.jsx";
import ProfileNotificationsSection from "./ProfileSections/ProfileNotificationsSection.jsx";
import { getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { logOut } from "../../utils/auxiliarFunctions.js";

const Perfil = () => {
  const navigate = useNavigate();
  const auth = getAuth();

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [qrCodeURL, setqrCodeURL] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [numeroSocio, setNumeroSocio] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [userData, setUserData] = useState(null);
  const [profileSection, setProfileSection] = useState('');
  const { user } = useAppContext();

  const obtenerDataUsuario = async () => {
    try {
      const correoUsuario = sessionStorage.getItem("correo");
      const dataUsuario = await getUserByEmail(correoUsuario);
      setUserData(dataUsuario[0]);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (!user) {
      obtenerDataUsuario();
    } else {
      setUserData(user);
    }
  }, []);

  useEffect(() => {
    if (userData) {
      setEmail(userData.email);
      setFirstName(userData.name);
      setLastName(userData.lastName);
      setqrCodeURL(userData.shortUrl || userData.email);
      setFechaNacimiento(userData.fechaNacimiento);
      setNumeroSocio(userData.numeroSocio);
      setProfileSection('contact');
    }
  }, [userData]);

  const handleLogOut = async () => {
    try {
      await logOut();
      sessionStorage.clear();
      navigate(`/`);
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <div>
      {userData ? (
        <Container>
          <Row className="m-0 p-0 py-4">
            <Col xs={12} md={3} className={style.selectSectionCol}>
              <h1 className={`mb-4 titles`}>Perfil</h1>
              <Button className={style.profileBtns} onClick={() => setProfileSection('contact')}>
                <CgProfile /> Datos de contacto
              </Button> <br />
              <Button className={style.profileBtns} onClick={() => setProfileSection('notifications')}>
                <IoMdNotificationsOutline /> Notificaciones
              </Button> <br />
              <Button className={style.profileBtns} onClick={handleLogOut}>
                <MdOutlineLogout /> Cerrar sesión
              </Button>
            </Col>
            <Col xs={12} md={9} className="px-md-5 mt-4 mt-md-0">
              {profileSection === 'contact' &&
                <ProfileContactSection
                  email={email}
                  setEmail={setEmail}
                  firstName={firstName}
                  setFirstName={setFirstName}
                  lastName={lastName}
                  setLastName={setLastName}
                  fechaNacimiento={fechaNacimiento}
                  setFechaNacimiento={setFechaNacimiento}
                  numeroSocio={numeroSocio}
                  setNumeroSocio={setNumeroSocio}
                  editMode={editMode}
                  setEditMode={setEditMode}
                />
              }

              {profileSection === 'notifications' &&
                <ProfileNotificationsSection />
              }
            </Col>
          </Row>
          <Toaster richColors position="bottom-center" />
        </Container>
      ) : (
        <div className='d-flex justify-content-center'><Spinner /></div>
      )}
    </div>
  );
};

export default Perfil;
